import { MerchFlowCoreRange } from "../merchandise";
import { GenerationCdtSource } from "./_merchflowId_/base-pog/_basePogId_";

export const RoutePostMerchflowsUhd = "/merchflows/uhd";

export interface PayloadFormPostMerchflowsUhd {
  name: string;
  notes?: string;
  goLiveDate: string;
  deactivationDate?: string | null;
  coreRangeOption: MerchFlowCoreRange;
  categoryCode: string;
  retailerCategoryCode: string;
  psaFile?: File;
}

export type PayloadPostMerchflowsUhd = FormData;

export interface ResponsePostMerchflowsUhd {
  id: number;
  filter_config_id: number;
  base_pog_id: number;
  category_code: string;
  retailer_category_code: string;
  generationCdtSource: GenerationCdtSource;
}
